import axios from "axios";

export const fetchUpdateParentCompany = async (data: any) => {
  const body = {
    companyName: data.companyName,
    organizationIds: data.organizationIds,
    clientAdminIds: data.clientAdminIds,
  };
  return await axios.post(`/api/parentcompany/${data.id}`, body);
};
